import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Row, Col, Input, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getVehicles, getVehicleOwners, removeVehicle } from "../../services/fleet"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import "../Tenancy/tenancy.css"

const VEHICLE_TYPES = ["BUS", "COASTER", "CAR", "PICK UP", "VAN"]

const fmtDate = d => (d ? String(d).slice(0, 10) : "—")

/**
 * Operations → Fleet: the vehicle master. Global (spans all owner companies). Add/Edit open a
 * separate page. Each vehicle carries an owner company + an auto-created Fixed-Asset ledger.
 */
const FleetList = () => {
  document.title = "Fleet | Calyvern"
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [owners, setOwners] = useState([])
  const [search, setSearch] = useState("")
  const [ownerId, setOwnerId] = useState("")
  const [type, setType] = useState("")
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    ;(async () => {
      try {
        const r = await getVehicleOwners()
        setOwners(r?.data || [])
      } catch (e) { toastError(e?.message) }
    })()
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const r = await getVehicles({ q: search, owner_id: ownerId, type })
        setRows(r?.data || [])
      } catch (e) { toastError(e?.message) }
    })()
  }, [search, ownerId, type, refresh])

  const onDelete = async v => {
    if (!window.confirm(`Remove vehicle ${v.plate_full || v.plate_no}? Its ledger is kept.`)) return
    try {
      const r = await removeVehicle(v.id)
      toastSuccess(r?.message || "Vehicle removed")
      setRefresh(n => n + 1)
    } catch (e) { toastError(e?.message) }
  }

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumbs title="Operations" breadcrumbObject={[
            { title: "Operations", link: "#" },
            { title: "Fleet", link: "#" },
          ]} />
          <Button color="primary" className="mb-3" onClick={() => navigate("/fleet/add")}>+ Vehicle</Button>
        </div>
        <Card className="tnt-page-card me-2 px-2 pb-2 main-dashboard-bg">
          <CardBody>
            <Row className="mb-2 g-2">
              <Col md={4}>
                <Input bsSize="sm" placeholder="Search plate / vehicle / chassis…" value={search} onChange={e => setSearch(e.target.value)} />
              </Col>
              <Col md={4}>
                <Input type="select" bsSize="sm" value={ownerId} onChange={e => setOwnerId(e.target.value)}>
                  <option value="">All owners</option>
                  {owners.map(o => <option key={o.id} value={o.id}>{o.company_name}</option>)}
                </Input>
              </Col>
              <Col md={4}>
                <Input type="select" bsSize="sm" value={type} onChange={e => setType(e.target.value)}>
                  <option value="">All types</option>
                  {VEHICLE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </Input>
              </Col>
            </Row>
            <Table responsive borderless className="align-middle tnt-table">
              <thead>
                <tr>
                  <th>Plate</th><th>Type</th><th>Vehicle</th><th>Owner</th><th>Driver</th>
                  <th>Mulkiya exp.</th><th>Insurance exp.</th><th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(v => (
                  <tr key={v.id}>
                    <td className="fw-semibold">{v.plate_full || v.plate_no || "—"}</td>
                    <td>{v.vehicle_type || "—"}</td>
                    <td>{v.name_of_vehicle || "—"}{v.model_year ? <span className="text-muted"> · {v.model_year}</span> : null}</td>
                    <td>{v.owner ? <span title={v.owner.company_name}>{v.owner.code}</span> : "—"}</td>
                    <td>{v.driver_name || "—"}</td>
                    <td>{fmtDate(v.mulkiya_expiry_date)}</td>
                    <td>{fmtDate(v.insurance_expiry_date)}</td>
                    <td className="text-end text-nowrap">
                      <i className="uil-pen action-icon" role="button" title="Edit" onClick={() => navigate(`/fleet/edit/${v.id}`)} />
                      <i className="uil-trash-alt action-icon danger" role="button" title="Remove" onClick={() => onDelete(v)} />
                    </td>
                  </tr>
                ))}
                {!rows.length && <tr><td colSpan="8" className="text-center text-muted">No vehicles yet.</td></tr>}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default FleetList
